import React from "react";
import { Datepicker } from "flowbite-react";
import { datePickerFormikTheme } from "@utils/datePickerTheme";

export default function FlowbiteDatepicker({
  name,
  value,
  handleOnChange,
  handleOnBlur,
  className,
  errorMsg,
  ref,
  ...restProps
}) {
  return (
    <Datepicker
      name={name}
      id={name}
      value={value}
      onChange={handleOnChange}
      onBlur={handleOnBlur}
      color="custom"
      theme={datePickerFormikTheme(errorMsg)}
      className={className}
      ref={ref}
      {...restProps}
    />
  );
}
